import React, { Component, Fragment } from 'react'
import { Helmet } from "react-helmet";


import Main from 'components/Main';
import Page from '@/modern/components/Page';

import { config } from 'config/config';

import './SiteMap.scss';

export default class PageSiteMap extends Component {
	constructor(props) {
		super(props);
		this.state = {
			title: 'Mapa do Site - Webmotors',
			description: 'Mapa do Site',
			urls: this.getUrlSiteMap()
		};
	}
	componentDidMount() {
	}
	renderHelmet() {
		return (<Fragment>
			<Helmet>
				{this.state.title ? <title>{this.state.title}</title> : ''}
				<meta name="language" content="pt-br" />
				{this.state.description ? <meta name="description" content={this.state.description} /> : ''}
				<meta property="og:url" content={this.props.location.href} />
				<link rel="canonical" href={this.state.canonical || ''} />
				<link rel="alternate" hreflang="pt-BR" href={this.state.canonical || ''} />
			</Helmet>
		</Fragment>)
	}
	getUrlSiteMap() {
		return {
			comprar: [
				{ name: 'Comprar' },
				{ name: 'Busca Avançada', url: config.urlAdvancedSearch },
				{ name: 'Carros por estado', url: `${config.urlMapSite}/carros`},
				{ name: 'Motos por estado', url: `${config.urlMapSite}/motos`}
			],
			vender: [
				{ name: 'Vender' },
				{ name: 'Anunciar meu carro', url: config.urlSellMyCar },
				{ name: 'Anunciar minha moto', url: config.urlSellMyBike },
				{ name: 'Perguntas frequentes', url: config.urlWMHelp },
			],
			tabelaFipe: [
				{ name: 'Tabela FIPE' },
				{ name: 'Tabela FIPE e Webmotors', url: config.urlTableFipe },
			],
			atendimento: [
				{ name: 'Atendimento' },
				{ name: 'Como vender seu veículo', url: config.urlHowToSell },
				{ name: 'Como comprar seu veículo', url: config.urlHowToBuy },
				{ name: 'Para a sua loja', url: config.urlLegalPerson },
			],
			wm1: [
				{ name: 'WM1' },
				{ name: 'WM1', url: config.urlNewsWM1 },
				{ name: 'Notícias', url: `${config.urlNewsWM1}noticias` },
				{ name: 'Comparativos', url: `${config.urlNewsWM1}comparativos` },
				{ name: 'Testes', url: `${config.urlNewsWM1}testes` },
				{ name: 'Vídeos', url: `${config.urlNewsWM1}videos-de-carros-e-motos` },
				{ name: 'Fotos', url: `${config.urlNewsWM1}fotos-de-carros-e-motos` },
				{ name: 'Lançamentos', url: `${config.urlNewsWM1}lancamentos` },
				{ name: 'Motos', url: `${config.urlNewsWM1}motos` },
				{ name: 'Bolso', url: `${config.urlNewsWM1}dinheiro-e-economia` },
				{ name: 'Cultura WM1', url: `${config.urlNewsWM1}cultura-auto` },
				{ name: 'Segredos', url: `${config.urlNewsWM1}segredos-auto` },
				{ name: 'Tecnologia', url: `${config.urlNewsWM1}tecnologia` },
				{ name: 'Marcas', url: `${config.urlNewsWM1}marcas` },
				{ name: 'Salões', url: `${config.urlNewsWM1}saloes` },
				{ name: 'Pit-Stop', url: `${config.urlNewsWM1}pit-stop` },
			],
			revendedor: [
				{ name: 'Revendedor' },
				{ name: 'Revendedor', url: config.urlCockPit },
				{ name: 'Perguntas frequentes', url: config.urlLegalPerson },
			],
			mobile: [
				{ name: 'Mobile' },
				{ name: 'App Iphone', url: config.urlAppIphone },
				{ name: 'App Android', url: config.urlAppAndroid },
			],
			sites: [
				{ name: 'Sites' },
				{ name: 'Banco Santander', url: config.urlSantander },
				{ name: 'Santander Sustentabilidade', url: `${config.urlSantander}sustentabilidade` },
				{ name: 'Compreauto', url: config.urlCompreAuto },
				{ name: 'Carsales', url: config.urlCarSales },
				{ name: 'ChileAutos', url: config.urlChileAutos },
				{ name: 'AutoCompara', url: config.urlAutoCompara },
				{ name: 'Tyresales', url: config.urlTyreSales },
			],
			minhaWebmotors: [
				{ name: 'Minha Webmotors' },
				{ name: 'Cadastro', url: `${config.urlLogin}https://garagem.webmotors.com.br/` },
			],
			financiar: [
				{ name: 'Financiar' },
				{ name: 'Simule um financiamento', url: config.urlFinancig },
			],
			redesSociais: [
				{ name: 'Redes Sociais' },
				{ name: 'Twitter', url: config.urlTwitter },
				{ name: 'Facebook', url: config.urlFacebook },
				{ name: 'Instagram', url: config.urlInstagram },
				{ name: 'Youtube', url: config.urlYoutube },
			],
			seguro: [
				{ name: 'Seguro' },
				{ name: 'Simule seu seguro', url: `${config.urlSantander}autocompara` },
			],
			institucional: [
				{ name: 'Institucional' },
				{ name: 'Publicidade', url: config.urlPublicity },
				{ name: 'Cód Defesa Consumidor', url: config.urlConsumerProtection },
				{ name: 'Trabalhe com a gente', url: config.urlWorkWithUs },
			]
		}
	}

	renderUrl(name) {
		let _newUrls = []
		this.state.urls[name].map((item, index) => {
			_newUrls.push(
				<a rel="noreferrer" key={`${name}_${index}`} target='_blank' href={item.url} className={index == 0 ? "SiteMap__link__title" : 'SiteMap__link'}>
					{item.name}
				</a>
			)
		})
		return _newUrls
	}
	renderContent() {
		return (<Fragment>
			<h1 role="heading" aria-level={1} className="hidden">Mapa do site</h1>
			<div className="SiteMap__container">
				<div className="SiteMap__column">
					{this.renderUrl('comprar')}
					{this.renderUrl('wm1')}
				</div>
				<div className="SiteMap__column">
					{this.renderUrl('vender')}
					{this.renderUrl('revendedor')}
					{this.renderUrl('minhaWebmotors')}
					{this.renderUrl('redesSociais')}

				</div>
				<div className="SiteMap__column">
					{this.renderUrl('tabelaFipe')}
					{this.renderUrl('mobile')}
					{this.renderUrl('financiar')}
					{this.renderUrl('seguro')}
					{this.renderUrl('institucional')}
				</div>
				<div className="SiteMap__column">
					{this.renderUrl('atendimento')}
					{this.renderUrl('sites')}
				</div>
			</div>
		</Fragment>)
	}
	render() {
		return (
			<Page openFooter={true}
				url={this.props.location}
			>
				{this.renderHelmet()}
				<Main className={'SiteMap'}>
					{this.renderContent()}
				</Main>
			</Page>
		)
	}
}
